// Spanish
export const locale = {
  lang: 'es',
  data: {
    CARD_FORM: {
      CARD_NUMBER: 'Número de Tarjeta',
      EXPIRATION_DATE: 'Fecha de Vencimiento',
      SECURITY_CODE: 'Código de Seguridad',
      INVALID_CARD_NUMBER: 'Número de tarjeta inválido',
      CARD_NUMBER_REQUIRED: 'El número de tarjeta es requerido',
      INVALID_EXPIRATION_DATE: 'Fecha de vencimiento inválida',
      EXPIRATION_DATE_REQUIRED: 'La fecha de vencimiento es requerida',
      CVC_REQUIRED: 'El CVC es requerido',
      CVC_LENGTH_INVALID: 'La longitud del CVC es inválida',
      ZIP: 'Código postal',
      ZIP_REQUIRED: 'El código postal es requerido',
      SAVE_FOR_FUTURE_PAYMENTS:
        'Este método de pago se guardará para pagos futuros.',
    },
    ERRORS: {
      AUTH_FAILED: 'Autenticación fallida',
      MISSING_TOKEN: 'Falta el parámetro de token',
      VALIDATION_FAILED: 'Validación fallida',
      SERVER_ERROR: 'Error del servidor',
    },
  },
};


